import React, { useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SuiTypography from "components/SuiTypography";
import AttachmentMenu from "./attachmentMenu";

const FileRow = ({ title, hasFile, onView, onUpdate }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleView = () => {
    onView();
    handleMenuClose();
  };

  const handleUpdate = () => {
    onUpdate();
    handleMenuClose();
  };

  return (
    <Grid item xs={12}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <SuiTypography variant="button" fontWeight="regular" color="text">
            {title}
          </SuiTypography>
        </Grid>
        <Grid item>
          <IconButton onClick={handleMenuOpen}>
            <MoreVertIcon />
          </IconButton>
          <AttachmentMenu
            anchorEl={anchorEl}
            onClose={handleMenuClose}
            hasFile={hasFile}
            onView={handleView}
            onUpdate={handleUpdate}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

FileRow.propTypes = {
  title: PropTypes.string.isRequired,
  hasFile: PropTypes.bool.isRequired,
  onView: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default FileRow;
